function formatBytes (value) {
    if (typeof value !== "undefined") {
        return Math.round(value/1000);
    }
    return "";
}

export default formatBytes;
